import { anonymizeLawTopicItemTitle } from './anonymize-law-topic-item-title'

export const transformRelatedLegisTitle = (
  title: string,
  prepositionForReference: string | null,
  forceSkip?: boolean
): string => {
  const normativeActWithNicknameRegex = /^(Art\. \d+[A-Za-z]?[ºª]?) (da|do|de) .+ \| (.+)$/i
  const normativeActWithNicknameMatch = title.match(normativeActWithNicknameRegex)
  const hasPreposition = !!prepositionForReference
  if (normativeActWithNicknameMatch) {
    const [, article, , nickname] = normativeActWithNicknameMatch
    const title = hasPreposition
      ? `${article} d${prepositionForReference} ${nickname}`
      : `${article}, ${nickname}`
    return anonymizeLawTopicItemTitle({ title, forceSkip })
  }

  const normativeActWithoutNicknameRegex =
    /^(Art\. \d+[A-Za-z]?[ºª]?) (da|do|de) ([\wÀ-ÿ-]+(?:\s[\wÀ-ÿ-]+)*) nº ([\d.]+), de (\d{1,2}) de ([A-Za-zÀ-ÿç]+) de (\d{4})$/i
  const normativeActWithoutNicknameMatch = title.match(normativeActWithoutNicknameRegex)
  if (normativeActWithoutNicknameMatch) {
    const [, article, preposition, normativeActType, normativeActNumber, , , year] =
      normativeActWithoutNicknameMatch
    return anonymizeLawTopicItemTitle({
      title: `${article} ${preposition} ${normativeActType} nº ${normativeActNumber}/${year}`,
      forceSkip,
    })
  }

  const wholeNormativeActWithDateRegex =
    /^([\wÀ-ÿ-]+(?:\s[\wÀ-ÿ-]+)*) nº ([\d.]+) de (\d{1,2}) de ([A-Za-zÀ-ÿç]+) de (\d{4})$/i
  const wholeNormativeActWithDateMatch = title.match(wholeNormativeActWithDateRegex)
  if (wholeNormativeActWithDateMatch) {
    const [, normativeActType, normativeActNumber, , , year] = wholeNormativeActWithDateMatch
    return anonymizeLawTopicItemTitle({
      title: `${normativeActType} nº ${normativeActNumber}/${year}`,
      forceSkip,
    })
  }

  return anonymizeLawTopicItemTitle({
    title,
    forceSkip,
  })
}
